export default {
    POST: 'POST',
};
  


// WEBPACK FOOTER //
// ./src/modules/organization/models/NotificationChannelHttpMethod.ts